import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighDetailedCollage = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g>
          <path
            d="M3.84009 5.4082C3.84009 4.57978 4.51166 3.9082 5.34009 3.9082H13.1381C13.9665 3.9082 14.6381 4.57978 14.6381 5.4082V9.35818C14.6381 10.1866 13.9665 10.8582 13.1381 10.8582H5.34009C4.51166 10.8582 3.84009 10.1866 3.84009 9.35818V5.4082Z"
            fill="url(#paint0_linear_7752_89216)"
            fillOpacity="0.8"
          />
          <path
            d="M18.9233 13.0849C18.9233 12.2565 19.5948 11.5849 20.4233 11.5849H24.5625C25.3909 11.5849 26.0625 12.2565 26.0625 13.0849V24.2459C26.0625 25.0743 25.3909 25.7459 24.5625 25.7459H20.4233C19.5948 25.7459 18.9233 25.0743 18.9233 24.2459V13.0849Z"
            fill="url(#paint1_linear_7752_89216)"
            fillOpacity="0.8"
          />
          <path
            d="M15.2645 5.4082C15.2645 4.57978 15.936 3.9082 16.7645 3.9082H24.5625C25.3909 3.9082 26.0625 4.57978 26.0625 5.4082V9.35818C26.0625 10.1866 25.3909 10.8582 24.5625 10.8582H16.7645C15.936 10.8582 15.2645 10.1866 15.2645 9.35818V5.4082Z"
            fill="url(#paint2_linear_7752_89216)"
            fillOpacity="0.8"
          />
          <path
            d="M3.84009 20.6411C3.84009 19.8127 4.51166 19.1411 5.34009 19.1411H9.08144C9.90986 19.1411 10.5814 19.8127 10.5814 20.6411V24.2463C10.5814 25.0747 9.90986 25.7463 9.08144 25.7463H5.34009C4.51166 25.7463 3.84009 25.0747 3.84009 24.2463V20.6411Z"
            fill="url(#paint3_linear_7752_89216)"
            fillOpacity="0.8"
          />
          <path
            d="M11.5931 20.6411C11.5931 19.8127 12.2647 19.1411 13.0931 19.1411H16.6215C17.45 19.1411 18.1215 19.8127 18.1215 20.6411V24.2463C18.1215 25.0747 17.45 25.7463 16.6215 25.7463H13.0931C12.2647 25.7463 11.5931 25.0747 11.5931 24.2463V20.6411Z"
            fill="url(#paint4_linear_7752_89216)"
            fillOpacity="0.8"
          />
          <path
            d="M3.84009 13.0849C3.84009 12.2565 4.51166 11.5849 5.34009 11.5849H16.6215C17.45 11.5849 18.1215 12.2565 18.1215 13.0849V16.8503C18.1215 17.6787 17.45 18.3503 16.6215 18.3503H5.34009C4.51166 18.3503 3.84009 17.6787 3.84009 16.8503V13.0849Z"
            fill="url(#paint5_linear_7752_89216)"
            fillOpacity="0.8"
          />
          <path
            d="M5.34009 19.3906H9.0813C9.77149 19.3906 10.331 19.9505 10.3313 20.6406V24.2461C10.3313 24.9365 9.77165 25.4961 9.0813 25.4961H5.34009C4.64973 25.4961 4.09009 24.9365 4.09009 24.2461V20.6406L4.09692 20.5137C4.16079 19.8832 4.69277 19.3906 5.34009 19.3906ZM13.093 19.3906H16.6213C17.3115 19.3906 17.8711 19.9505 17.8713 20.6406V24.2461C17.8713 24.9365 17.3117 25.4961 16.6213 25.4961H13.093C12.4027 25.496 11.843 24.9364 11.843 24.2461V20.6406C11.8433 19.9505 12.4029 19.3907 13.093 19.3906ZM20.4231 11.835H24.5627C25.253 11.8351 25.8127 12.3947 25.8127 13.085V24.2461C25.8126 24.9363 25.2529 25.496 24.5627 25.4961H20.4231C19.7329 25.496 19.1732 24.9363 19.1731 24.2461V13.085C19.1731 12.3947 19.7328 11.8351 20.4231 11.835ZM5.34009 11.835H16.6213C17.3117 11.835 17.8713 12.3946 17.8713 13.085V16.8506C17.8712 17.5408 17.3116 18.1006 16.6213 18.1006H5.34009C4.64984 18.1006 4.09027 17.5408 4.09009 16.8506V13.085C4.09009 12.3946 4.64973 11.835 5.34009 11.835ZM5.34009 4.1582H13.1379C13.8283 4.1582 14.3879 4.71785 14.3879 5.4082V9.3584C14.3878 10.0487 13.8282 10.6084 13.1379 10.6084H5.34009C4.6498 10.6084 4.0902 10.0487 4.09009 9.3584V5.4082C4.09009 4.71785 4.64973 4.1582 5.34009 4.1582ZM16.7649 4.1582H24.5627C25.253 4.15835 25.8127 4.71794 25.8127 5.4082V9.3584C25.8126 10.0486 25.2529 10.6083 24.5627 10.6084H16.7649C16.0746 10.6084 15.515 10.0487 15.5149 9.3584V5.4082C15.5149 4.71785 16.0745 4.1582 16.7649 4.1582Z"
            stroke="url(#paint6_linear_7752_89216)"
            strokeOpacity="0.6"
            strokeWidth="0.5"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_7752_89216"
            x1="9.0322"
            y1="15.2835"
            x2="11.1294"
            y2="10.5082"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F335BE" />
            <stop offset="0.295" stopColor="#F33551" />
            <stop offset="1" stopColor="#FF8B04" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_7752_89216"
            x1="9.0322"
            y1="15.2835"
            x2="11.1294"
            y2="10.5082"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F335BE" />
            <stop offset="0.295" stopColor="#F33551" />
            <stop offset="1" stopColor="#FF8B04" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_7752_89216"
            x1="9.0322"
            y1="15.2835"
            x2="11.1294"
            y2="10.5082"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F335BE" />
            <stop offset="0.295" stopColor="#F33551" />
            <stop offset="1" stopColor="#FF8B04" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_7752_89216"
            x1="9.0322"
            y1="15.2835"
            x2="11.1294"
            y2="10.5082"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F335BE" />
            <stop offset="0.295" stopColor="#F33551" />
            <stop offset="1" stopColor="#FF8B04" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_7752_89216"
            x1="9.0322"
            y1="15.2835"
            x2="11.1294"
            y2="10.5082"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F335BE" />
            <stop offset="0.295" stopColor="#F33551" />
            <stop offset="1" stopColor="#FF8B04" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_7752_89216"
            x1="9.0322"
            y1="15.2835"
            x2="11.1294"
            y2="10.5082"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F335BE" />
            <stop offset="0.295" stopColor="#F33551" />
            <stop offset="1" stopColor="#FF8B04" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_7752_89216"
            x1="10.4992"
            y1="11.5848"
            x2="10.4992"
            y2="18.8686"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default HighDetailedCollage
